import { PhoneCall, ClipboardCheck, PencilRuler, HardHat, Headset } from "lucide-react";
import { IMAGES } from "@/config/site";
import { Reveal, SectionHeading } from "./Motion";

const STEPS = [
  { icon: PhoneCall, t: "Call / Chat", d: "Just call or message us" },
  { icon: ClipboardCheck, t: "Free Site Survey", d: "We check your roof and load" },
  { icon: PencilRuler, t: "Custom Design + Finance", d: "Right system, easy finance" },
  { icon: HardHat, t: "Installation", d: "Done by our expert team" },
  { icon: Headset, t: "Service", d: "Support after installation" },
];

export const HowItWorks = () => (
  <section id="process" data-testid="how-it-works-section" className="section-pad relative">
    <div className="container-x grid gap-12 lg:grid-cols-2 lg:gap-16">
      <div className="lg:sticky lg:top-28 lg:self-start">
        <SectionHeading eyebrow="How it works" title="Solar in 5 Easy Steps" />
        <Reveal delay={0.15} className="relative mt-10 overflow-hidden rounded-3xl border border-slate-200">
          <img src={IMAGES.technicians} alt="Technicians installing solar panels" loading="lazy" className="h-72 sm:h-96 w-full object-cover" />
          <div className="glass absolute bottom-4 left-4 rounded-2xl px-5 py-3">
            <div className="font-display text-lg font-bold text-navy-900">On-site Expert Team</div>
            <div className="text-sm text-slate-600">Survey · Installation · Service</div>
          </div>
        </Reveal>
      </div>
      <ol className="relative space-y-4">
        {STEPS.map((s, i) => (
          <Reveal key={s.t} delay={i * 0.08}>
            <li data-testid={`process-step-${i + 1}`} className="glass card-lift group flex items-center gap-5 rounded-3xl p-5 sm:p-6">
              <div className="relative grid h-16 w-16 shrink-0 place-items-center rounded-2xl bg-gold/10 ring-1 ring-gold/30 transition-colors duration-300 group-hover:bg-gold">
                <s.icon className="h-7 w-7 text-gold-ink transition-colors duration-300 group-hover:text-navy-950" />
                <span className="absolute -right-2 -top-2 grid h-7 w-7 place-items-center rounded-full bg-cream-50 text-sm font-bold text-gold-ink ring-1 ring-gold/50">{i + 1}</span>
              </div>
              <div>
                <h3 className="font-display text-xl sm:text-2xl font-bold text-navy-900">{s.t}</h3>
                <p className="mt-1 text-[17px] text-slate-600">{s.d}</p>
              </div>
            </li>
          </Reveal>
        ))}
      </ol>
    </div>
  </section>
);
